import img01 from '../assets/images/img01.jpg';
import img02 from '../assets/images/img02.jpg';
import img03 from '../assets/images/img03.jpg';
import gif01 from '../assets/images/gif01.gif';
import gif02 from '../assets/images/gif02.gif';

export const postList = [
  {
    id: 0,
    image: img01,
    title: '#1: How far from Earth is the ISS ?',
    text: `The International Space Station moves in space approximately 400km away from Earth.`,
    credit: `NASA's image gallery.`,
    url: 'https://www.nasa.gov/mission_pages/station/images/index.html'
  },
  {
    id: 1,
    image: img02,
    title: '#2: Where does the oxygen come from ?',
    text: `There are 3 answers for this question:
    1 - Astronauts get oxygen through Electrolysis, splitting the oxygen from hydrogen on Water (molecular formula H2O), by using electricity (in short); 2 - Astronauts carry oxygen in their spaceships when they go to the space station; 3 - They get oxygen when they receive supplies by uncrewed spacecraft.`,
    credit: `NASA's image gallery.`,
    url: 'https://www.nasa.gov/mission_pages/station/images/index.html'
  },
  {
    id: 2,
    image: img03,
    title: '#3: What is the purpose of the Space Station ?',
    text: `The purpose of the station, at first, was to support experiments in a microgravity environment and to observe and monitor the earth. But currently, its purpose is related to supporting increasingly longer space travels.`,
    credit: `NASA's image gallery.`,
    url: 'https://www.nasa.gov/mission_pages/station/images/index.html'
  },
  {
    id: 3,
    image: gif01,
    title: '#4: How did the Iss get into space ?',
    text: `The space station did not get into space assembled. It was assembled piece by piece, and this assembly process took about 13 years to complete. Starting in 1998 and officially ending in 2011.`,
    credit: `TED-Ed Animations`,
    url: 'https://ed.ted.com/lessons/the-incredible-collaboration-behind-the-international-space-station-tien-nguyen'
  },
  {
    id: 4,
    image: gif02,
    title: '#5: How fast is the space station ?',
    text: `Traveling at an average speed of 27.558 km/h, the space station makes 16 orbits of Earth, travelling through 16 sunrises and sunsets`,
    credit: `NASA's Tumblr account.`,
    url: 'https://nasa.tumblr.com/post/142901384634/space-station-research-observing-earth'
  }
];
